"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFrontendValidationFeedbackATPlus = exports.useGetFrontendValidationFeedback = void 0;
const react_i18next_1 = require("react-i18next");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const ToastIcon_1 = require("../../../../../components/Shared/ToastIcon");
const luxon_1 = require("luxon");
const useGetFrontendValidationFeedback = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const payDataList = props.updatePayDataRequest.payDataItems[0].payData;
    const payDataListWithInvalidInputDate = payDataList.filter((payData) => {
        const beginDate = luxon_1.DateTime.fromSQL(payData.beginDateTime.slice(0, 10));
        const endDate = luxon_1.DateTime.fromSQL(payData.endDateTime.slice(0, 10));
        const beginDateDiff = getDateDiffFromSelectedDate(beginDate, props.selectedDate);
        const endDateDiff = getDateDiffFromSelectedDate(endDate, props.selectedDate);
        return (beginDateDiff > 1 ||
            beginDateDiff < 0 ||
            endDateDiff > 1 ||
            endDateDiff < 0);
    });
    if (!(0, isEmpty_1.default)(payDataListWithInvalidInputDate)) {
        return {
            status: ToastIcon_1.ToastIconStatus.error,
            message: t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_FrontendValidation_DateError`)
        };
    }
    return;
};
exports.useGetFrontendValidationFeedback = useGetFrontendValidationFeedback;
const useGetFrontendValidationFeedbackATPlus = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return props.isUpdateSelfClassification
        ? editPayCodeFrontendValidation(props, t)
        : addPayCodeFrontendValidation(props, t);
};
exports.useGetFrontendValidationFeedbackATPlus = useGetFrontendValidationFeedbackATPlus;
const addPayCodeFrontendValidation = (props, t) => {
    const payCodeList = props.addPayCodeRequest.payCodeInputBody;
    const payCodeListWithInvalidInputDate = payCodeList.filter((payCode) => {
        const startDateTimeWithTimezone = luxon_1.DateTime.fromISO(payCode.startDateTime, {
            zone: props.timezone
        });
        const startDate = startDateTimeWithTimezone.toISODate();
        const endDate = startDateTimeWithTimezone
            .plus({
            hours: isNaN(payCode.duration) ? 0 : payCode.duration
        })
            .toISODate();
        const startDateDiff = getDateDiffFromSelectedDate(luxon_1.DateTime.fromISO(startDate), props.selectedDate);
        const endDateDiff = getDateDiffFromSelectedDate(luxon_1.DateTime.fromISO(endDate), props.selectedDate);
        return (startDateDiff > 1 ||
            startDateDiff < 0 ||
            endDateDiff > 1 ||
            endDateDiff < 0);
    });
    if (!(0, isEmpty_1.default)(payCodeListWithInvalidInputDate)) {
        return {
            status: ToastIcon_1.ToastIconStatus.error,
            message: t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_FrontendValidation_DateError`)
        };
    }
    return;
};
const editPayCodeFrontendValidation = (props, t) => {
    const payCodeList = props.editPayCodeRequest.updatePayCodeBody;
    const payCodeListWithInvalidInputDate = payCodeList.filter((payCode) => {
        const startDateTimeWithTimezone = luxon_1.DateTime.fromISO(payCode.updatedPayCodeBody.payCodeInputBody.startDateTime, {
            zone: props.timezone
        });
        const startDate = startDateTimeWithTimezone.toISODate();
        const endDate = startDateTimeWithTimezone
            .plus({
            hours: isNaN(payCode.updatedPayCodeBody.payCodeInputBody.duration)
                ? 0
                : payCode.updatedPayCodeBody.payCodeInputBody.duration
        })
            .toISODate();
        const startDateDiff = getDateDiffFromSelectedDate(luxon_1.DateTime.fromISO(startDate), props.selectedDate);
        const endDateDiff = getDateDiffFromSelectedDate(luxon_1.DateTime.fromISO(endDate), props.selectedDate);
        return (startDateDiff > 1 ||
            startDateDiff < 0 ||
            endDateDiff > 1 ||
            endDateDiff < 0);
    });
    if (!(0, isEmpty_1.default)(payCodeListWithInvalidInputDate)) {
        return {
            status: ToastIcon_1.ToastIconStatus.error,
            message: t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_FrontendValidation_DateError`)
        };
    }
    return;
};
const getDateDiffFromSelectedDate = (targetDate, selectedDate) => {
    const normalizedSelectedDate = luxon_1.DateTime.fromSQL(selectedDate.toSQLDate());
    return targetDate
        .diff(normalizedSelectedDate, ['months', 'days', 'hours'])
        .toObject().days;
};
